import { render, staticRenderFns } from "./ListItemRelationships.vue?vue&type=template&id=5ecdd512"
import script from "./ListItemRelationships.vue?vue&type=script&lang=js"
export * from "./ListItemRelationships.vue?vue&type=script&lang=js"
import style0 from "./ListItemRelationships.vue?vue&type=style&index=0&id=5ecdd512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports